import Accordion from 'accordion-js';

export default class PageHeader {
	isFixed = false;
	isOpen = false;
	lastScrollTop = window.pageYOffset;

	constructor(props) {
		this.resetFlyout = ::this.resetFlyout;
		this.onMouseOver = ::this.onMouseOver;
		this.onMouseOut = ::this.onMouseOut;
		this.showNextDeepMenu = ::this.showNextDeepMenu;
		this.header = document.querySelector(props.header);
		this.hamburger = document.querySelector(props.hamburger);
		this.searchOverlay = document.querySelector(props.searchOverlay);
		this.searchBar = document.querySelector(props.searchBar);
		this.searchOverlayToggles = Array.from(document.querySelectorAll(props.searchOverlayToggle));
		this.languageMenus = Array.from(document.querySelectorAll(props.languageMenu));
		this.languageMenuToggle = props.languageMenuToggle;
		this.mainNavItems = Array.from(document.querySelectorAll('.js-main-nav-item'));
		this.openNavElems = Array.from(document.querySelectorAll(props.openNavElem));
		this.deepMenus = Array.from(document.querySelectorAll('.js-nav-deep-menu'));
		this.navMenuItems = Array.from(document.querySelectorAll('.js-nav-menu-item'));
		// this.closeNavElem = document.querySelector(props.closeNavElem);
		this.navAccordions = Array.from(document.querySelectorAll(props.navAccordion));
		this.setUp();
	}

	setUp = () => {
		this.setUpNav();
		this.setUpStickyHeader();
		this.setUpLanguageMenu();
		this.setUpSearchOverlay();
		this.setUpNavAccordion();
	};

	setUpNav = () => {
		this.hamburger.addEventListener('click', () => {
			this.toggleNav({ open: !this.isOpen });
		});

		this.navMenuItems.forEach(item => {
			item.addEventListener('mouseover', this.onMouseOver);
			item.addEventListener('mouseout', this.onMouseOut);
		});

		this.openActiveNavItem();
		this.setSpacer();

		this.mainNavItems.forEach(item => item.addEventListener('mouseenter', this.resetFlyout));
	};

	setUpStickyHeader = () => {
		document.addEventListener('scroll', () => {
			if (window.pageYOffset > 30) this.toggleIsFixed({ fix: true });
			else this.toggleIsFixed({ fix: false });
		});
	};

	setUpLanguageMenu = () => {
		this.languageMenus.forEach(menu => {
			const languageMenuToggle = menu.querySelector(this.languageMenuToggle);
			languageMenuToggle.addEventListener('click', () => this.toggleLanguageMenu(menu));
		});
	};

	setUpSearchOverlay = () => {
		this.searchOverlayToggles.forEach(toggler => {
			toggler.addEventListener('click', () => this.toggleSearchOverlay());
		});
	};

	setUpNavAccordion = () => {
		this.navAccordions.forEach(accordion => {
			new Accordion(accordion, {
				duration: 300,
				elementClass: 'js-navAccordionElement',
				triggerClass: 'js-navAccordionTrigger',
				panelClass: 'js-navAccordionPanel',
				activeClass: 'is-active',
			});
		});
	};

	toggleIsFixed = ({ fix }) => {
		this.header.classList[fix ? 'add' : 'remove']('is-fixed');
		this.isFixed = fix;
	};

	toggleNav = ({ open = false, withDelay = false } = {}) => {
		clearTimeout(this.toggleInterval);
		const timeout = withDelay ? 200 : 10;
		const action = open ? this.openNav : this.closeNav;
		this.toggleInterval = setTimeout(action, timeout);
	};

	openNav = () => {
		this.isOpen = true;
		this.header.classList.add('is-open');
		this.lastScrollTop = window.pageYOffset;
	};

	closeNav = () => {
		this.isOpen = false;
		this.header.classList.remove('is-open');
	};

	toggleSearchOverlay = () => {
		this.searchOverlay.classList.toggle('is-open');
		if (this.searchOverlay.classList.contains('is-open')) {
			setTimeout(() => {
				this.searchBar.focus();
			}, 100);
		}
	};

	toggleLanguageMenu = menu => {
		menu.classList.toggle('is-open');
	};

	onMouseOver(e) {
		const { currentTarget } = e;

		const { uid, baseUid } = currentTarget.dataset;
		this.nextUid = uid;
		this.nextBaseUid = baseUid;

		this.showTimeout = setTimeout(this.showNextDeepMenu, 100);
	}

	onMouseOut() {
		clearTimeout(this.showTimeout);
	}

	resetFlyout(e) {
		const { currentTarget } = e;
		const mainNavItem = currentTarget.querySelector('.js-nav-image-wrapper-absolute');
		mainNavItem && mainNavItem.classList.remove('hidden');
		this.openActiveNavItem(currentTarget);
	}

	showNextDeepMenu(hideMainnavItem = true) {
		this.deepMenus.forEach(menu => {
			if (menu.dataset.baseUid === this.nextBaseUid) {
				if (menu.dataset.pid === this.nextUid) {
					menu.classList.add('is-visible');
				} else {
					menu.classList.remove('is-visible');
				}
			}
		});

		this.navMenuItems.forEach(item => {
			if (item.dataset.baseUid === this.nextBaseUid) {
				if (item.dataset.uid === this.nextUid) {
					if (item.classList.contains('sub')) {
						item.classList.add('is-active');
					}
					item.classList.remove('is-not-active');
				} else {
					item.classList.add('is-not-active');
					item.classList.remove('is-active');
				}
			}
		});

		if (hideMainnavItem) {
			const hoverItem = document.querySelector(`.js-nav-menu-item[data-uid="${this.nextUid}`);
			const mainNavItem = hoverItem.parentNode.parentNode.querySelector(
				'.js-nav-image-wrapper-absolute'
			);
			mainNavItem && mainNavItem.classList.add('hidden');
		}
	}

	openActiveNavItem(source = document) {
		const firstNavItems = Array.from(
			document.querySelectorAll('.js-sub-page > [data-level="0"]:first-child')
		);

		firstNavItems.forEach(navItem => {
			const { uid, baseUid } = navItem.dataset;
			this.nextUid = uid;
			this.nextBaseUid = baseUid;
			this.showNextDeepMenu(false);
			const existingNavImage = source.querySelector(
				`.js-nav-deep-menu[data-uid="${uid}"] .js-nav-image-wrapper`
			);
			if (existingNavImage) {
				const imageWrapper = navItem.parentNode.parentNode.querySelector(
					'.js-nav-image-wrapper-absolute'
				);
				imageWrapper && imageWrapper.classList.add('hidden');
			}
		});

		const currentActive = source.querySelector('.js-nav-menu-item.current-active');

		if (currentActive) {
			const { uid, baseUid } = currentActive.dataset;
			this.nextUid = uid;
			this.nextBaseUid = baseUid;
			this.showNextDeepMenu();

			const imageWrapper = currentActive.parentNode.querySelector('.js-nav-image-wrapper-absolute');
			imageWrapper && imageWrapper.classList.add('hidden');
		}

		const initialOpenNavPoints = Array.from(source.querySelectorAll('[data-initial-open="1"]'));
		initialOpenNavPoints.forEach(navPoint => {
			const { pid, baseUid } = navPoint.dataset;
			this.nextUid = pid;
			this.nextBaseUid = baseUid;
			this.showNextDeepMenu();

			const imageWrapper = navPoint.parentNode.parentNode.querySelector(
				'.js-nav-image-wrapper-absolute'
			);
			imageWrapper && imageWrapper.classList.add('hidden');
		});
	}

	setSpacer() {
		document.querySelectorAll('.js-nav-image-wrapper:first-child').forEach(el => {
			const navSIzer = el.parentNode.parentNode.querySelector('.js-nav-sizer');
			navSIzer && navSIzer.classList.add('nav-flyout__menu-sizer--one');
		});
	}
}
